import axios from "axios"
import { translate } from "src/utils/translation"

export class BaseService {
  protected static getToken() {
    return localStorage.getItem("auth.AccessToken")
  }

  protected static getFilters(filters: any = {}) {
    let url_params = ""
    Object.keys(filters).forEach((filter_name) => {
      if (url_params === "") {
        url_params = `?${filter_name}=${filters[filter_name]}`
      } else {
        url_params += `&${filter_name}=${filters[filter_name]}`
      }
    })

    return url_params
  }

  protected static async refreshToken() {
    try {
      const res = await axios.post("/api/v1/admin/token/refresh/", {
        refresh: localStorage.getItem("auth.RefreshToken"),
      })
      localStorage.setItem("auth.AccessToken", res.data.access)
      return 1
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 401) {
          return -1
        }
      }
      return 0
    }
  }

  protected static async callAPI(params: any = {}) {
    try {
      if (params.headers) {
        params.headers["ngrok-skip-browser-warning"] = "true"
      }
      return await axios({ ...params })
    } catch (e: any) {
      if (e.response?.status === 401) {
        const res = await this.refreshToken()
        if (res === 1) {
          params.headers.Authorization = `Bearer ${this.getToken()}`
          return await axios({ ...params })
        }
      }
      throw e
    }
  }

  protected static getErrorInfo(error: any) {
    if (error.response) {
      if (error.response.data.message) {
        return {
          isSuccess: false,
          message: error.response.data.message,
          errors: [],
          data: {},
          status: error.response.status as number,
        }
      } else if (error.response.data.detail) {
        return {
          isSuccess: false,
          message: error.response.data.detail,
          errors: [],
          data: {},
          status: error.response.status as number,
        }
      } else {
        return {
          isSuccess: false,
          message: "",
          errors: error.response.data,
          data: {},
          status: error.response.status as number,
        }
      }
    } else if (error.request) {
      return {
        isSuccess: false,
        message: translate(
          "messages.failure_in_sending_request",
          localStorage.getItem("preferences.Lang") || "ar"
        ),
        errors: [],
        data: {},
        status: 0,
      }
    } else {
      return {
        isSuccess: false,
        message: translate(
          "messages.failure_in_calling_server",
          localStorage.getItem("preferences.Lang") || "ar"
        ),
        errors: [],
        data: {},
        status: -1,
      }
    }
  }

  protected static getSuccessInfo(response: any) {
    if (response.data.message) {
      return {
        isSuccess: true,
        message: response.data.message,
        errors: [],
        data: {},
        status: response.status as number,
      }
    } else {
      return {
        isSuccess: true,
        message: "",
        errors: [],
        data: response.data,
        status: response.status as number,
      }
    }
  }
}
